import React, { Component }       from 'react';
import PropTypes                  from 'prop-types';
import { Segment, Header, Grid }  from 'semantic-ui-react';

import ResponseForm                           from 'containers/ResponseForm';
import connectResource                        from 'utils/connectResource';
import { getById }                            from 'utils/connectors';
import { internalForms, internalFormRecords } from 'resources/organizationResources';

// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

class NewRecordForm extends Component {
  constructor(props) {
    super(props);

    this.handleSave  = this.handleSave.bind(this);
  }

  render() {
    const { data={}, loading }  = this.props;
    const form                  = data.form || {};
    const { name }              = form;

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Segment loading={ loading }>
              <Header as='h2'>{ name }</Header>
            </Segment>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Segment loading={ loading }>
              <Header as='h3'>New Record</Header>
              <div style={{ marginTop: '2rem' }}>
              <ResponseForm form={ form } onSave={ this.handleSave } />
              </div>
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  async handleSave(answers, done) {
    const { match: { params: { id } },
            dispatch,
            history }  = this.props;

    const formFieldAnswers = Object.entries(answers).map(([field_id, value]) => {
      return { field_id, ...value };
    });

    const params = {
      answers: formFieldAnswers
    };

    const scope = {
      form_id: id
    };

    const request   = internalFormRecords.actions.create(params, scope);
    const response  = await dispatch(request);

    if(!response.errors) {
      history.push(`/organization/internal_form_responses/${id}`);
    }

    done();
  }
}

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

NewRecordForm.defaultProps = {
  loading: false
};

NewRecordForm.propTypes = {
  loading:  PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  history:  PropTypes.object.isRequired,
  data:     PropTypes.shape({
    form: PropTypes.object
  }).isRequired
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

export default connectResource(NewRecordForm, {
  connectors: {
    form: getById(internalForms, ({ match: { params: { id } } }) => id)
  }
});
